/**
 * Created by maty on 13/02/2017.
 */

export class Pagination {
    current_page: number = 1;
    results_per_page: number = 25;
    total_results: number = 0;
    total_pages: number = 0;
    start_offset: number = 0;
    results_current_page: number = 0;
}


// WEBPACK FOOTER //
// ./src/app/entities/pagination.ts